var viewer_figure_default = {
  "figure": "Berpf"
};
export {
  viewer_figure_default as default
};
//# sourceMappingURL=viewer-figure-scss.js.map
